import { post } from './request'

export async function email(formData) {
  return await post('/api/invalid/email', formData)
}

